const translations = {
  en: {
    // Auth
    welcome_back: "Welcome back",
    sign_in_desc: "Sign in to access your ESG reports",
    email: "Email",
    password: "Password",
    sign_in: "Sign In",
    no_account: "Don't have an account?",
    create_one: "Create one",
    create_account: "Create account",
    start_building: "Start building professional ESG reports",
    full_name: "Full Name",
    min_chars: "Min 6 characters",
    already_have: "Already have an account?",
    sign_in_link: "Sign in",
    // Dashboard
    dashboard: "Dashboard",
    your_reports: "Your ESG Reports",
    manage_reports: "Manage and generate professional ESG reports",
    new_report: "New Report",
    esg_news: "ESG World News",
    esg_news_tooltip: "Real, sourced ESG news from regulators and global media, refined by AI.",
    no_reports: "No reports yet",
    no_reports_desc: "Create your first ESG report to get started",
    complete: "Complete",
    draft: "Draft",
    logout: "Logout",
    // Report Builder
    back_to_dashboard: "Dashboard",
    step: "Step",
    of: "of",
    company: "Company",
    environment: "Environment",
    social: "Social",
    governance: "Governance",
    generate: "Generate",
    next: "Next",
    back: "Back",
    // Company Step
    company_info_hint: "These details form the cover page and introduction of your ESG report. Company name and sector are required.",
    company_information: "Company Information",
    basic_details: "Basic details used throughout the report",
    company_name: "Company Name",
    industry_sector: "Industry Sector",
    select_sector: "Select sector...",
    reporting_year: "Reporting Year",
    country_operation: "Country of Operation",
    num_employees: "Number of Employees",
    ceo_director: "CEO / Managing Director",
    website: "Website",
    company_description: "Company Description",
    describe_company: "Briefly describe what your company does...",
    leadership_statement: "Leadership ESG Statement",
    ceo_message: "A brief message from your CEO about sustainability...",
    report_images: "Report Images",
    report_images_desc: "Upload images for key report sections. These appear in the PDF with professional green frames.",
    // Environment Step
    env_hint: "Fill in what you know. Use the built-in converters to estimate CO2e from everyday figures like litres of diesel or kWh bills.",
    scope1_title: "Scope 1, Direct Emissions",
    scope1_desc: "Emissions from sources your company owns: vehicles, generators, gas boilers",
    scope1_label: "Scope 1 CO2e (tCO2e/year)",
    scope1_hint: "Auto-filled from converter or type manually",
    scope1_converter: "Scope 1 Converter",
    scope2_title: "Scope 2, Purchased Electricity",
    scope2_desc: "Indirect emissions from electricity or district cooling from the grid",
    scope2_label: "Scope 2 CO2e (tCO2e/year)",
    scope2_converter: "Scope 2 Converter",
    scope3_title: "Scope 3, Value Chain (Optional)",
    scope3_desc: "Business travel, commuting, purchased goods, waste disposal",
    scope3_label: "Scope 3 CO2e (tCO2e/year)",
    scope3_converter: "Scope 3 Converter",
    energy_targets: "Energy & Targets",
    total_energy: "Total Energy (kWh/year)",
    renewable_share: "Renewable Energy Share (%)",
    annual_revenue: "Annual Revenue (AED)",
    energy_intensity: "Energy Intensity (kWh/AED 1,000)",
    reduction_target: "Reduction Target",
    climate_risk: "Climate Risk Assessment (TCFD)",
    water_waste: "Water & Waste",
    water_consumption: "Water Consumption (m3/year)",
    water_recycled: "Water Recycled (%)",
    total_waste: "Total Waste (tonnes/year)",
    landfill_rate: "Landfill Rate (%)",
    env_initiatives: "Key Environmental Initiatives",
    env_images: "Environmental Images",
    env_images_desc: "Upload images for the Environmental Strategy section of the PDF",
    // Social Step
    social_hint: "Social data focuses on your people, safety, wellbeing, diversity and development. Heavily weighted in GCC/ADX reporting.",
    workforce_metrics: "Workforce Metrics",
    workforce_desc: "People data for the reporting year",
    total_employees_label: "Total Employees",
    female_pct: "Female Employees (%)",
    local_pct: "Nationalization / Local Workforce (%)",
    training_hours: "Training Hours per Employee",
    injury_rate: "Lost-Time Injury Rate (LTIR)",
    csr_spend: "CSR Spend / Community Investment",
    supply_chain_practices: "Supply Chain Practices",
    wellbeing_programs: "Wellbeing Programs",
    hr_policies: "HR Policies",
    social_images: "Social Section Images",
    social_images_desc: "Upload images for Social sections of the PDF",
    // Governance Step
    gov_hint: "Governance data covers your board, ethics, compliance and ESG oversight. Critical for ADX reporting requirements.",
    governance_metrics: "Governance Metrics",
    governance_desc: "Board oversight, ethics and compliance data",
    board_size: "Board Size",
    board_female: "Female Board Members (%)",
    independent_directors: "Independent Directors (%)",
    anti_corruption: "Anti-Corruption Policy",
    whistleblower: "Whistleblower Mechanism",
    data_protection: "Data Protection Policy",
    code_of_conduct: "Code of Conduct",
    esg_committee: "ESG Committee",
    improvement_plan: "Improvement Plan",
    gov_image: "Governance Section Image",
    gov_image_desc: "Upload a hero image for the Governance section divider page",
    // Generate Step
    scores_summary: "ESG Scores Summary",
    environmental_label: "Environmental",
    social_label: "Social",
    governance_label: "Governance",
    overall_score: "Overall ESG Score",
    ready_generate: "Ready to Generate Your Report",
    generate_desc: "AI will write a comprehensive 60+ page professional ESG report based on your data, aligned with GRI Universal Standards 2021, TCFD Recommendations, ADX ESG Disclosure Guidelines, DFM ESG Reporting Guide, and the UN Sustainable Development Goals (structured to be forward-ready for ISSB and CSRD).",
    generate_button: "Generate ESG Report",
    generating_text: "Generating...",
    // Report View
    esg_report: "ESG Report",
    download_pdf: "Download PDF",
    edit_data: "Edit Data",
    regenerate: "Regenerate prose (same data)",
    branding: "Branding",
    download_full: "Download Full PDF Report (60+ pages)",
    pdf_desc: "Professional PDF with cover page, data tables, charts, GRI index and more",
    // Selects
    yes_formal: "Yes, Formal policy in place",
    in_development: "In Development",
    no_option: "No",
    yes_anonymous: "Yes, Anonymous reporting channel available",
    yes_compliant: "Yes, PDPL/GDPR compliant",
    select_option: "Select...",

    // ─── Navigation ───
    nav_home: "Home",
    nav_why_us: "Why Us",
    nav_features: "Features",
    nav_creator: "Creator",
    nav_founders: "Founders",
    nav_get_started: "Get Started",
    nav_pricing: "Pricing",
    hero_price_line_amount: "$499/year",
    hero_price_line_offer: "50% off until October 31",
    hero_price_line_link: "See pricing",
    pricing_cta_sample_first: "View Sample First",
    pricing_risk_reversal: "Preview your full report before you pay.",
    nav_compare: "View Sample",
    nav_sample: "View Sample",
    nav_sign_in: "Sign In",
    nav_sign_up: "Free Sign Up",
    nav_back_home: "Back to Home",
    nav_advisors: "ESG Professionals",
    loading: "Loading",
    cancel: "Cancel",

    // ─── ESG Professionals ───
    advisors_eyebrow: "ESG Professionals Network",
    advisors_title: "ESG Professionals",
    advisors_subtitle: "A directory of independent sustainability professionals and consultancies. Browse profiles, filter by country, city or specialty, and get in touch directly.",
    advisors_generate_mine: "Generate Your Profile",
    advisors_edit_my: "Edit My Profile",
    advisors_search_placeholder: "Search name, company, keyword…",
    advisors_search_btn: "Search",
    advisors_clear: "Clear",
    advisors_all_countries: "All countries",
    advisors_all_cities: "All cities",
    advisors_all_services: "All services",
    advisors_empty_title: "No professional matches your filters yet.",
    advisors_empty_hint: "Try widening your search, or be the first to publish a profile.",
    advisors_not_found: "Professional not found.",
    advisors_back_gallery: "Back to the gallery",
    advisors_pending_banner: "Your profile is pending admin approval. It will appear in the gallery once reviewed.",
    advisors_rejected_title: "Profile rejected",
    advisors_about: "About",
    advisors_services: "Services",
    advisors_contact: "Contact",
    advisors_create_title: "Generate your Professional Profile",
    advisors_edit_title: "Edit your Professional Profile",
    advisors_form_subtitle: "Fill in your details below. Fields marked * are mandatory. Your profile goes live after admin review.",
    advisors_f_image: "Profile image (logo or portrait)",
    advisors_f_company_name: "Company name",
    advisors_f_first_name: "First name",
    advisors_f_last_name: "Last name",
    advisors_f_email: "Email",
    advisors_f_phone: "Phone",
    advisors_f_city: "City",
    advisors_f_country: "Country",
    advisors_f_hero_message: "Hero message",
    advisors_f_bio: "Short bio",
    advisors_f_services: "Services",
    advisors_f_website: "Website (optional)",
    advisors_f_linkedin: "LinkedIn (optional)",
    advisors_hero_hint: "One short line that captures your value proposition. 160 characters max.",
    advisors_bio_placeholder: "Tell potential clients who you are, your experience, and the kind of mandates you take on. Minimum 20 characters.",
    advisors_services_hint: "Pick as many as apply. Can't find yours? Add a custom one below.",
    advisors_custom_tag_placeholder: "Add a custom specialty…",
    advisors_add: "Add",
    advisors_change_image: "Change image",
    advisors_upload_image: "Upload image",
    advisors_image_hint: "JPEG, PNG or WEBP. Max 5 MB. Squared center-crop applied, shown as a circle.",
    advisors_image_too_big: "Image must be under 5 MB",
    advisors_missing_field: "Missing required field",
    advisors_missing_image: "Please upload a profile image",
    advisors_pick_tag: "Please pick at least one service",
    advisors_bio_short: "Bio must be at least 20 characters",
    advisors_save: "Save changes",
    advisors_create_submit: "Create my profile",
    advisors_saved_pending: "Saved! Profile is pending admin review.",
    advisors_delete: "Delete profile",
    advisors_delete_confirm: "Delete your professional profile? This cannot be undone.",
    advisors_deleted: "Profile deleted.",

    // ─── Landing Hero ───
    hero_badge: "FREE SIGN-UP · NO CREDIT CARD · NO OBLIGATION",
    hero_title_a: "Professional ESG Reports.",
    hero_title_b: "In Less Than One Hour, Not Months.",
    hero_desc: "Generate 60+ page professional ESG reports aligned with GRI, TCFD, ADX, DFM, UN SDGs, ISSB and CSRD. In English and Arabic. Built for SMEs. At 1/100th the cost of the top corporate ESG reporting tools.",
    hero_free_intro: "Sign up for free in 10 seconds and get right away:",
    hero_free_1: "Free access to your private dashboard",
    hero_free_2: "Free access to ESG World News, the daily curated GCC + global feed",
    hero_free_3: "Generate your first ESG report, downloading a 10-page preview for free",
    hero_unlock_intro: "When you're ready, unlock and get:",
    hero_unlock_1: "Your first report, ready to download",
    hero_unlock_2: "365 days of unlimited new report generations",
    hero_unlock_3: "Unlimited amendments to every report you own",
    hero_price_line: "One Flat Fee (early-bird until 31 October): $499 for the full year. No auto-renewal, no upsells, no add-ons.",
    hero_reassurance: "No credit card at signup. Pay only when you unlock.",
    popup_start_free: "Start Free",
    popup_close: "Close",
    hero_cta_start: "Get Started For Free",
    hero_cta_subscribe: "Subscribe",
    hero_cta_learn: "Learn More",
    hero_cta_assumptions: "Required Assumptions",
    hero_cta_compare: "View Sample",
    hero_cta_sample: "View Sample",
    badge_gri: "GRI",
    badge_tcfd: "TCFD",
    badge_adx: "ADX",
    badge_dfm: "DFM",
    badge_sdg: "UN SDGs",
    badge_issb: "ISSB",
    badge_csrd: "CSRD",
    badge_forward_label: "Forward-ready",

    // ─── Sample Page ───
    sample_eyebrow: "Real Output · Real Quality",
    sample_hero_a: "This is what your report",
    sample_hero_b: "will look like.",
    sample_hero_desc: "Ten actual pages from a generated Sample Report, same professional output you'll deliver to investors, regulators, and stakeholders. Available in English and Arabic.",
    sample_badge_pages: "60+ Pages",
    sample_badge_bilingual: "Bilingual EN / AR",
    sample_click_zoom: "Click to zoom",
    sample_cta_start: "Get Started",
    sample_cta_title: "Ready to generate yours?",
    sample_cta_desc: "From data entry to a 60+ page assessor-ready report in less than one hour. No templates. No agencies. Just your numbers, expertly authored.",
    sample_cta_button: "Start My Report",
    // Per-slide captions
    sample_caption_cover:       "A bold, framework-aligned cover. Upload your company logo and a custom background image for strong brand identity, or keep it clean with any solid colour you choose.",
    sample_caption_toc:         "A clear roadmap across 31 sections, Overview, E, S, G, and 8 standards-mapped appendices.",
    sample_caption_materiality: "A double-materiality matrix plotting your topics against business and societal impact.",
    sample_caption_sia:         "Every action you took mapped to UN SDGs, UNGC Principles, and DFM ESG Codes, assessor-grade traceability.",
    sample_caption_env:         "Pillar opener with striking visual identity for each section, E, S, G. Upload any background image to give the divider personality and reinforce your brand story.",
    sample_caption_energy:      "Energy summary, source mix doughnut, and a detailed breakdown of every fuel and renewable input.",
    sample_caption_yoy:         "Year-over-year deltas with directional arrows, quick wins, real talk on regressions.",
    sample_caption_social:      "Social Performance section opener, workforce, safety, diversity, training, community, supply chain. Upload any background image to give the divider personality.",
    sample_caption_workforce:   "Employee data, gender by management level, age distribution, the diversity story in numbers.",
    sample_caption_gov:         "Governance Framework, board oversight, ethics, data protection, ESG integration. Upload any background image to give the divider personality.",

    // ─── Register / Sign Up ───
    reg_title: "Create Free Account",
    reg_title_suffix: "(No Card Required)",
    reg_subtitle: "Start building professional ESG reports",
    reg_benefit_headline: "Start building your first professional ESG report, for free.",
    reg_benefit_sub: "No credit card. No commitment. Just build",
    reg_benefit_1: "Free sign up, no card needed",
    reg_benefit_2: "Build your first ESG report for free, download a 10-page Preview Edition",
    reg_benefit_3: "Your ESG report stays in your dashboard for 3 days",
    reg_benefit_4: "Unlimited free access to the \"ESG World News\" feed",
    reg_benefit_5: "Subscribe to unlock your full 60+ page ESG report (English and Arabic versions), plus unlimited report generations and unlimited amendments on existing reports",
    // ─── Tutorial video ───
    tut_eyebrow: "2-MINUTE TOUR",
    tut_card_title: "See how it works in 2 minutes",
    tut_card_sub: "Start Now Your ESG Journey With Us!",
    tut_pill_label: "Watch 2-min tour",
    tut_close: "Close",
    // ─── Subscribe (/subscribe) mode ───
    sub_banner_eyebrow: "One flat fee · Early bird",
    sub_banner_price: "$499 / year",
    sub_banner_sub: "Full 60+ page ESG report (EN + AR), unlimited generations & amendments. No auto-renewal.",
    sub_form_title: "Create Account to Subscribe",
    sub_form_subtitle: "Complete your details, then finalize payment on the next step.",
    sub_submit: "Pay Now to Subscribe",
    sub_company: "Company name",
    sub_company_ph: "Your company name",
    sub_phone: "Phone number",
    sub_phone_ph: "e.g. +971 50 123 4567",
    sub_err_company: "Please enter your company name.",
    sub_err_phone: "Please enter a valid phone number.",
    reg_company: "Company Name",
    reg_company_ph: "Your company name",
    reg_firstname: "First Name",
    reg_firstname_ph: "First name",
    reg_surname: "Surname",
    reg_surname_ph: "Surname",
    reg_role: "Role / Title",
    reg_role_ph: "e.g. CEO, ESG Manager",
    reg_phone: "Phone Number",
    reg_email: "Email",
    reg_email_ph: "you@company.com",
    reg_password: "Password",
    reg_password_ph: "Min 6 characters",
    reg_submit: "Create Free Account",
    reg_have_account: "Already have an account?",
    reg_signin_link: "Sign in",
    reg_err_password_len: "Password must be at least 6 characters",
    reg_err_company: "Company name is required",
    reg_err_firstname: "First name is required",
    reg_err_surname: "Surname is required",
    reg_err_role: "Please enter your role / job title.",
    reg_err_phone: "Please enter a valid phone number.",
    reg_err_generic: "Registration failed",
    login_forgot_password: "Forgot password?",

    // ─── Forgot Password ───
    fp_title: "Reset your password",
    fp_subtitle: "Enter your email and we'll send you a reset link.",
    fp_email: "Email",
    fp_email_ph: "you@company.com",
    fp_submit: "Send Reset Link",
    fp_back_login: "Back to Sign In",
    fp_err_generic: "Something went wrong. Please try again.",
    fp_sent_title: "Check your email",
    fp_sent_msg_a: "If an account exists for ",
    fp_sent_msg_b: ", we've sent a password reset link. Check your inbox and spam folder.",

    // ─── Reset Password ───
    rp_invalid_title: "Invalid Reset Link",
    rp_invalid_msg: "This password reset link is invalid or has expired.",
    rp_invalid_link: "Request a new one",
    rp_title: "Set new password",
    rp_subtitle: "Enter your new password below.",
    rp_new: "New Password",
    rp_confirm: "Confirm Password",
    rp_pw_ph: "Min 6 characters",
    rp_confirm_ph: "Repeat your password",
    rp_submit: "Reset Password",
    rp_done_title: "Password Reset!",
    rp_done_msg: "Your password has been updated. You can now sign in.",
    rp_signin: "Sign In",
    rp_back_login: "Back to Sign In",
    rp_err_pw_len: "Password must be at least 6 characters",
    rp_err_mismatch: "Passwords do not match",
    rp_err_generic: "Failed to reset password. The link may have expired.",

    back_to_home: "Back to Home",

    // ─── Disrupting / Why Us ───
    why_eyebrow: "Why ESG Report Builder",
    why_title_a: "Disrupting the ESG",
    why_title_b: "Report Market",
    why_p1_strong: "ESG reporting",
    why_p1_rest: " has been gatekept by expensive consultants charging from $50,000 up to $150,000 or even more for large enterprises per report, making it inaccessible to the millions of SMEs that form the backbone of the GCC economy.",
    why_p2_strong: "We're changing that.",
    why_p2_rest: " ESG Report Builder delivers professional, 60+ page ESG reports, fully aligned with GRI Universal Standards 2021, TCFD Recommendations, ADX ESG Disclosure Guidelines, DFM ESG Reporting Guide, and the UN Sustainable Development Goals (structured to be forward-ready for ISSB and CSRD), at ",
    why_p2_highlight: "almost 1/100th the cost",
    why_p2_tail: " of the top corporate ESG reporting tools.",
    why_p3_strong: "Our bilingual engine",
    why_p3_rest: " generates reports in both English and Arabic with a single click, something no competitor offers at any price point. Every section is fully customizable, enriched with your company images, branded with your logo and colours.",
    why_p4_pre: "Our vision is simple: ",
    why_p4_strong: "democratise ESG reporting",
    why_p4_rest: ". Every company, even the smallest business, deserves the right to start their sustainability journey and have a professional document supporting their growth, credit score, and access to green funding.",
    why_p5_pre: "Our report is an ",
    why_p5_strong: "excellent tool for SMEs",
    why_p5_mid: " willing to manage their ESG reporting internally, and, equally, a ",
    why_p5_strong2: "highly credible ESG draft report for larger companies and ESG consultants",
    why_p5_rest: ", providing a solid foundation from which to consolidate relevant data without spending months, before producing a more tailored enterprise-grade ESG report.",
    stat1_value: "90%",
    stat1_title: "Cost Savings",
    stat1_desc: "Compared to the top corporate ESG reporting tools",
    stat2_value: "60+",
    stat2_title: "Pages Per Report",
    stat2_desc: "Professional customizable PDF with cover, content, image uploader, data tables, charts, GRI index, stakeholder toolkit, and AI-driven content based on your business and assumptions",
    stat3_value: "EN/AR",
    stat3_title: "Bilingual Reports",
    stat3_desc: "Generate in English, translate to Arabic with one click, or vice versa. Market first.",

    // ─── Features ───
    features_eyebrow: "Platform Features",
    features_title: "Everything You Need",
    features_subtitle: "Built specifically for GCC/MENA SMEs entering the ESG reporting journey",
    feat_ai_title: "AI-Powered Generation",
    feat_ai_desc: "Advanced AI writes comprehensive, sector-specific ESG content aligned with global frameworks",
    feat_pdf_title: "60+ Page Professional PDF",
    feat_pdf_desc: "Cover page, executive summary, data tables, KPIs, GRI index, stakeholder toolkit, all auto-generated",
    feat_bilingual_title: "Bilingual EN/AR",
    feat_bilingual_desc: "Full Arabic translation with RTL support. Generate or translate with one click",
    feat_co2_title: "CO2 Calculators",
    feat_co2_desc: "Built-in Scope 1, 2 & 3 emissions calculators with GCC-specific grid factors",
    feat_brand_title: "Full Branding",
    feat_brand_desc: "Upload your logo, pick your brand colours. Add company images to key sections",
    feat_standards_title: "GRI · TCFD · ADX · DFM · SDGs",
    feat_standards_desc: "Aligned with GRI Universal Standards 2021, TCFD Recommendations, ADX ESG Disclosure Guidelines, DFM ESG Reporting Guide, and the UN Sustainable Development Goals (structured to be forward-ready for ISSB and CSRD).",
    feat_bench_title: "GCC Benchmarks",
    feat_bench_desc: "Compare your performance against regional industry averages with built-in benchmarking",
    feat_matrix_title: "Materiality Matrix",
    feat_matrix_desc: "Auto-generated double materiality assessment with visual bubble chart",
    feat_stake_title: "Stakeholder Toolkit",
    feat_stake_desc: "Ready-made investor emails, LinkedIn posts, and press templates included in every report",

    // ─── Creator ───
    creator_eyebrow: "The Creator",
    creator_title: "Meet the Mind Behind the Platform",
    creator_location: "Dubai, UAE",
    creator_name: "David Provenzani",
    creator_role: "Senior Commercial Leader | MENA & GCC Specialist",
    creator_bio: "With over 25 years of executive leadership in renewable energy and infrastructure, David built ESG Report Builder from a simple conviction: every company, regardless of size, deserves access to professional ESG reporting without the prohibitive costs of traditional consulting.",
    creator_credit1_title: "Honorary Professor",
    creator_credit1_sub: "Amity University Dubai",
    creator_credit2_title: "30+ Years in Sustainability Sector",
    creator_credit2_sub: "Renewable energy, infrastructure & ESG advisory",
    creator_credit3_title: "Serial Entrepreneur & Senior Director",
    creator_credit3_sub: "15 years of experience in the GCC",
    creator_credit4_title: "Founder, Dubai Solar Schools Programme",
    creator_credit4_sub: "Pioneering sustainability education in the UAE",
    creator_credit5_title: "Top 50 AI Personalities in the Gulf Region",
    creator_credit5_sub: "Source: Deep Knowledge Analytics",

    // ─── Trust / Data Integrity ───
    trust_eyebrow: "Data Integrity by Design",
    trust_title_a: "Six defensive layers.",
    trust_title_b: "Zero numeric contradictions.",
    trust_desc: "Every quantitative claim in your report is reconciled by an automated data-integrity pipeline before publication, the same discipline audit-firm clients demand of Sphera, Workiva and Watershed.",
    trust_l1_title: "Canonical Source of Truth",
    trust_l1_desc: "Every KPI, from Scope 1/2/3 emissions to LTIR, training hours and gender ratios, lives once in a single database record. Narratives, ribbons, KPI tiles, executive summaries, TOC, PDF charts and Arabic translations all read from that exact same value. There is no path in the code where the AI, the layout engine or the translator can introduce a competing figure, guaranteeing every page of your report reconciles to the number you originally typed in the form.",
    trust_l2_title: "Prompt-Time Enforcement",
    trust_l2_desc: "The AI receives your canonical figures inside a locked prompt scaffold with 40+ hard-coded prohibitions: never invent a metric, never substitute a total for a scope, never re-sum components, never bracket a figure with a competing target, never round differently between EN and AR. Any narrative the model attempts to write that contradicts your data is regenerated up to three times, then blocked outright. This eliminates the class of hallucination that broke ESG reports at Salesforce and JPMorgan in 2024.",
    trust_l3_title: "Post-Generation Scrubs (34 fixers)",
    trust_l3_desc: "Thirty-four regex-based canonical fixers rewrite Scope 1/2/3 hallucinations, LTIR contradictions, GHG YoY drift ('down X% from Y to Y' bugs), gender-split miscounts, currency swaps, contractor-injury false claims, concatenated-number bugs, third-party assurance claims, GCC benchmark drift, SDG target-count errors, stakeholder-count inconsistencies, country-grid-factor confusion, prior-year metric cross-contamination (water/waste/diesel/gas), current-year metric cross-contamination, reduction-target vs YoY-actual confusion, materiality-topic-count drift, and energy-vs-GHG unit-confusion.",
    trust_l4_title: "Render-Time Re-Check",
    trust_l4_desc: "Milliseconds before WeasyPrint composes the final PDF, a second scrub pass re-scans every paragraph against the canonical KPI ledger, catching drift the LLM introduced during translation, sentence expansion or paragraph reordering. If the last-mile pass finds any contradiction, the block is rewritten from the canonical value or trimmed rather than shipped. Belt-and-suspenders redundancy that has caught 71 real drift incidents across production reports since Jan 2026.",
    trust_l5_title: "EN ↔ AR Parity Lock",
    trust_l5_desc: "Arabic paragraphs are structurally capped to the English source, character parity ≥ 0.90, so both editions carry byte-identical figures, byte-identical bullet counts and byte-identical table rows. The Arabic pipeline cannot silently expand or shrink content the way generic MT engines do, and every currency symbol, decimal separator and RTL digit shape is normalized. Your Arabic-speaking investors read the exact same numbers as your English-speaking board.",
    trust_l6_title: "Pinned Regression Tests",
    trust_l6_desc: "Six integrity tests, including a SHA-256 report-lock, a canonical-numbers-in-EN-PDF test, an EN/AR page-count parity test, a materiality-topic-drift test, a Scope-2 grid-factor test and a training-hours-round-trip test, are pinned in the CI pipeline. No future code change, refactor or model upgrade can ship if it silently regresses any of the six data-integrity guarantees. Every deploy proves the guarantees still hold before your customers ever see the new build.",
    trust_footer: "Full 6-layer methodology is disclosed inside every PDF (Data Integrity Statement · GRI 2-4 · GRI 2-5 · ESRS 1 BP-2).",

    // ─── Pricing ───
    pricing_eyebrow: "Get Started",
    pricing_title_a: "One Plan.",
    pricing_title_b: "Unlimited Reports.",
    pricing_discount_banner: "Limited Offer · 50% OFF until October 31, 2026",
    pricing_price: "$499",
    pricing_per_year: "/year",
    pricing_strike: "$999/year",
    pricing_discount_note: ", 50% discount until October 31, 2026",
    feature_unlimited: "Unlimited ESG reports",
    feature_pdf: "60+ page professional PDF",
    feature_bilingual: "Bilingual EN/AR",
    feature_ai_content: "AI-powered content",
    feature_branding: "Brand customization",
    feature_standards: "GRI, TCFD, ADX, DFM, UN SDGs alignment",
    feature_uploads: "Image uploads per section",
    feature_toolkit: "Stakeholder toolkit",
    feature_benchmarks: "GCC benchmarks",
    feature_matrix: "Materiality matrix",
    // ─── Pricing: Human Assistance hooks ───
    pricing_human_badge: "Human-Powered",
    pricing_human_title: "Real people. Real help. Included.",
    pricing_human_1_title: "Direct line to our CEO",
    pricing_human_1_desc: "After subscribing, you receive our CEO's personal WhatsApp number. He welcomes you personally and walks you through your next steps.",
    pricing_human_2_title: "Real-time guidance on your first report",
    pricing_human_2_desc: "We stay on the line while you build your first ESG report, every question, every field, every export. You are never alone.",
    pricing_human_footnote: "This is not chatbot support. This is founder-level human assistance, included in your subscription.",
    pricing_soon_title: "Live Now",
    pricing_soon_desc: "Pay once, get a full year of unlimited ESG reports, in English and Arabic. Lock in the launch discount before Oct 31, 2026.",
    interest_placeholder: "Your email address",
    interest_cta: "Reserve My Spot",
    interest_sending: "Sending…",
    interest_success_title: "You're on the list!",
    interest_success_desc_pre: "We'll notify you at ",
    interest_success_desc_post: " when the platform launches with your 50% discount locked in.",
    interest_error_generic: "Couldn't submit right now, please try again or email info@architaly.green.",
    have_account_pre: "Already have an account? ",
    have_account_link: "Sign in",

    // ─── Footer ───
    footer_copy: "© 2026 ESG Report Builder Corp. All rights reserved.",
    footer_location: "Delaware, USA",
    footer_terms: "Terms",
    footer_privacy: "Privacy",
    footer_refund: "Refunds",

    // ─── Compare page ───
    compare_eyebrow: "Competitive Landscape  •  Feb 2026",
    compare_title_a: "How ESG Report Builder",
    compare_title_b: "compares to every credible alternative.",
    compare_intro: "We audited every major ESG reporting platform serving SMEs and enterprises, from Fortune-2000 giants like Workiva and Datamaran, to European SME tools like Greenly and Pelt8, to regional GCC players like Olive Gaea. Here's the honest landscape and where ESG Report Builder sits in it.",
    compare_cta_jump: "Jump to side-by-side",
    compare_players: "players",
    compare_ideal_for: "Ideal for",
    compare_output: "Output",
    compare_gap: "Gap vs. Us",
    compare_matrix_eyebrow: "The Side-by-Side",
    compare_matrix_title: "Where ESG Report Builder sits",
    compare_col_dim: "Dimension",
    compare_col_others: "Everyone else",
    compare_yes: "Yes",
    compare_no: "No",
    compare_partial: "Partial",
    compare_cta_title_pre: "If you're an SME, start your ESG journey with unlimited, highly professional reports for only ",
    compare_cta_title_price: "$499/yr",
    compare_cta_desc: "The same 85-page editorial-grade ESG report, in English and Arabic, aligned with GRI, TCFD, ADX, DFM and UN SDGs, at 1/100th the price of the top corporate ESG reporting tools.",
    compare_sources: "Sources: fitgap.com, G2, Capterra, vendor websites, ESG Today, press releases, audited February 2026.",

    // Compare Tier 1
    tier1_label: "TIER 1, ENTERPRISE GIANTS",
    tier1_range: "$50K – $500K+ / year",
    tier1_note: "Built for Fortune 2000 and publicly-listed multinationals. Not your buyer, but useful benchmarks.",
    // Compare Tier 2
    tier2_label: "TIER 2, EUROPEAN SME / MID-MARKET",
    tier2_range: "$3K – $80K+ / year",
    tier2_note: "Closest pricing tier, but EU-focused (CSRD/ESRS). No Arabic, no GCC, no editorial-grade PDFs.",
    // Compare Tier 3
    tier3_label: "TIER 3, GCC / UAE REGIONAL PLAYERS",
    tier3_range: "Our actual battleground",
    tier3_note: "The real fight. Most are consultancies, not software. Only one is a genuine direct competitor.",

    // ─── Report View section titles & dividers ───
    rv_eyebrow: "ESG Report",
    badge_adx_aligned: "ADX Aligned",
    badge_tcfd_framework: "TCFD Framework",
    badge_gri_standards: "GRI Standards",
    score_environmental: "Environmental",
    score_social: "Social",
    score_governance: "Governance",
    score_overall: "Overall",
    sec_executive_summary: "Executive Summary",
    sec_ceo_letter: "CEO Letter",
    sec_company_overview: "Company Overview",
    sec_materiality: "Materiality Assessment",
    div_environmental: "Environmental Performance",
    sec_env_strategy: "Environmental Strategy",
    sec_ghg: "GHG Emissions Analysis",
    sec_energy: "Energy Management",
    sec_water: "Water Stewardship",
    sec_waste: "Waste Management",
    sec_climate_tcfd: "Climate Risk & TCFD",
    sec_env_targets: "Environmental Targets",
    div_social: "Social Performance",
    sec_social_strategy: "Social Strategy",
    sec_workforce: "Workforce Diversity",
    sec_health: "Health & Safety",
    sec_training: "Training & Development",
    sec_community: "Community Engagement",
    sec_supply: "Supply Chain",
    div_governance: "Governance",
    sec_gov_framework: "Governance Framework",
    sec_board: "Board Composition",
    sec_ethics: "Ethics & Compliance",
    sec_privacy: "Data Privacy",
    sec_esg_gov: "ESG Governance",
    div_appendices: "Appendices",
    sec_stakeholder: "Stakeholder Engagement",
    sec_sdg: "UN SDG Alignment",
    sec_methodology: "Methodology",
    sec_forward: "Forward-Looking Statements",
    download_btn_prefix: "Download PDF",
    preparing: "Preparing...",
    translate_prompt_pre: "Want the report in ",
    translate_prompt_mid: "? Click ",
    translate_prompt_post: " above.",
    lang_en_name: "English",
    lang_ar_name: "Arabic (عربي)",
    save_branding_btn: "Save Branding",
    saving: "Saving...",
    report_branding: "Report Branding",
    report_branding_desc: "Customize the PDF with your brand logo and colors",
    company_logo: "Company Logo",
    upload_logo: "Upload Logo",
    translation_missing_title: "Arabic translation not yet generated",
    translation_missing_desc: "You're viewing this report in Arabic mode, but the body text hasn't been translated yet. Click the button below to generate a full Arabic translation (≈ 3–5 min).",
    translation_missing_cta: "Translate to Arabic now",
    translation_missing_en_title: "English translation not yet generated",
    translation_missing_en_desc: "You're viewing this report in English mode, but the body text hasn't been translated yet. Click the button below to generate a full English translation (≈ 3–5 min).",
    translation_missing_en_cta: "Translate to English now",
    translation_in_progress: "Translating… this takes 3–5 minutes. You can leave this page and come back.",

    // ─── Uncle Dave (Help widget) ───
    uncledave_open: "Need help?",
    uncledave_greeting: "Hey, I'm Uncle Dave 👋",
    uncledave_subtitle: "What's on your mind? I'll pass it to our team and they'll reply ASAP.",
    uncledave_email_label: "Your email",
    uncledave_email_placeholder: "you@company.com",
    uncledave_msg_label: "Your question",
    uncledave_msg_placeholder: "Tell me what's going on…",
    uncledave_send: "Send to the team",
    uncledave_sending: "Sending…",
    uncledave_success_title: "Got it!",
    uncledave_success_body: "I've passed your message to our customer care team, they'll get in touch ASAP at the email you provided.",
    uncledave_close: "Close",
    uncledave_error: "Couldn't send your message. Please try again or email info@architaly.green directly.",
    // Report Builder (navigation + progress)
    step_company: "Company",
    step_environment: "Environment",
    step_social: "Social",
    step_governance: "Governance",
    step_generate: "Generate",
    progress_step: "Step",
    progress_of: "of",
    report_richness: "Report richness",
    richness_tooltip: "Live report richness. Everything you type is scored instantly. Aim for 70%+ across all three pillars for a full-bodied report.",
    pillars_below_40_one: "pillar below 40%",
    pillars_below_40_many: "pillars below 40%",
    add_more_data: ", add more data to unlock a richer narrative.",
    // Preflight / low-coverage modals
    heads_up_single: "Heads up, 1 data issue detected",
    heads_up_many: "Heads up, {n} data issues detected",
    preflight_body: "We noticed the following before generating your report. Fixing them now will produce a stronger, more defensible report. You can also continue and the AI will note the gaps honestly in the disclosures.",
    let_me_fix: "Let me fix them",
    continue_anyway: "Continue anyway",
    lowcov_body: "A comprehensive ESG report expects meaningful data across all three pillars. The following section(s) are sparsely filled, so the AI will have very little to work with and the resulting chapters will look thin to a reader.",
    only_x_filled: "only {n}% filled",
    fix_now: "Fix now →",
    let_me_fill_more: "Let me fill more",
    generate_anyway: "Generate anyway",
    nudge_title: "Quick wins to lift your report",
    nudge_fill_these: "Fill these fields to strengthen",
  },
  ar: {
    // Auth
    welcome_back: "مرحباً بعودتك",
    sign_in_desc: "سجّل الدخول للوصول إلى تقارير ESG الخاصة بك",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    sign_in: "تسجيل الدخول",
    no_account: "ليس لديك حساب؟",
    create_one: "أنشئ حساباً",
    create_account: "إنشاء حساب",
    start_building: "ابدأ في إنشاء تقارير ESG احترافية",
    full_name: "الاسم الكامل",
    min_chars: "6 أحرف كحد أدنى",
    already_have: "لديك حساب بالفعل؟",
    sign_in_link: "تسجيل الدخول",
    // Dashboard
    dashboard: "لوحة التحكم",
    your_reports: "تقارير ESG الخاصة بك",
    manage_reports: "إدارة وإنشاء تقارير ESG المهنية",
    new_report: "تقرير جديد",
    esg_news: "أخبار ESG العالمية",
    esg_news_tooltip: "أخبار ESG حقيقية وموثّقة من الجهات التنظيمية والإعلام العالمي، يصقلها الذكاء الاصطناعي.",
    no_reports: "لا توجد تقارير بعد",
    no_reports_desc: "أنشئ أول تقرير ESG للبدء",
    complete: "مكتمل",
    draft: "مسودة",
    logout: "تسجيل الخروج",
    // Report Builder
    back_to_dashboard: "لوحة التحكم",
    step: "الخطوة",
    of: "من",
    company: "الشركة",
    environment: "البيئة",
    social: "الاجتماعي",
    governance: "الحوكمة",
    generate: "إنشاء",
    next: "التالي",
    back: "السابق",
    // Company Step
    company_info_hint: "تُشكّل هذه البيانات صفحة الغلاف ومقدمة تقرير ESG. اسم الشركة والقطاع مطلوبان.",
    company_information: "معلومات الشركة",
    basic_details: "البيانات الأساسية المستخدمة في التقرير",
    company_name: "اسم الشركة",
    industry_sector: "القطاع الصناعي",
    select_sector: "اختر القطاع...",
    reporting_year: "سنة التقرير",
    country_operation: "بلد العمليات",
    num_employees: "عدد الموظفين",
    ceo_director: "الرئيس التنفيذي / المدير العام",
    website: "الموقع الإلكتروني",
    company_description: "وصف الشركة",
    describe_company: "صِف بإيجاز ما تقوم به شركتك...",
    leadership_statement: "بيان القيادة حول ESG",
    ceo_message: "رسالة مختصرة من الرئيس التنفيذي حول الاستدامة...",
    report_images: "صور التقرير",
    report_images_desc: "ارفع صوراً لأقسام التقرير الرئيسية. تظهر في ملف PDF بإطارات خضراء احترافية.",
    // Environment Step
    env_hint: "املأ ما تعرفه. استخدم المحولات المدمجة لتقدير انبعاثات CO2e من أرقام يومية مثل لترات الديزل أو فواتير الكهرباء.",
    scope1_title: "النطاق 1، الانبعاثات المباشرة",
    scope1_desc: "الانبعاثات من مصادر تملكها شركتك: المركبات والمولدات والغلايات",
    scope1_label: "النطاق 1 CO2e (طن CO2e/سنة)",
    scope1_hint: "يُملأ تلقائياً من المحول أو أدخله يدوياً",
    scope1_converter: "محول النطاق 1",
    scope2_title: "النطاق 2، الكهرباء المشتراة",
    scope2_desc: "الانبعاثات غير المباشرة من الكهرباء أو التبريد المركزي",
    scope2_label: "النطاق 2 CO2e (طن CO2e/سنة)",
    scope2_converter: "محول النطاق 2",
    scope3_title: "النطاق 3، سلسلة القيمة (اختياري)",
    scope3_desc: "السفر التجاري، التنقل، البضائع المشتراة، التخلص من النفايات",
    scope3_label: "النطاق 3 CO2e (طن CO2e/سنة)",
    scope3_converter: "محول النطاق 3",
    energy_targets: "الطاقة والأهداف",
    total_energy: "إجمالي الطاقة (كيلوواط ساعة/سنة)",
    renewable_share: "حصة الطاقة المتجددة (٪)",
    annual_revenue: "الإيرادات السنوية (درهم)",
    energy_intensity: "كثافة الطاقة (كيلوواط ساعة/1000 درهم)",
    reduction_target: "هدف الخفض",
    climate_risk: "تقييم المخاطر المناخية (TCFD)",
    water_waste: "المياه والنفايات",
    water_consumption: "استهلاك المياه (م³/سنة)",
    water_recycled: "المياه المعاد تدويرها (٪)",
    total_waste: "إجمالي النفايات (طن/سنة)",
    landfill_rate: "معدل الدفن (٪)",
    env_initiatives: "المبادرات البيئية الرئيسية",
    env_images: "الصور البيئية",
    env_images_desc: "ارفع صوراً لقسم الاستراتيجية البيئية في ملف PDF",
    // Social Step
    social_hint: "تركز البيانات الاجتماعية على موظفيك، السلامة والرفاهية والتنوع والتطوير. ذات وزن كبير في تقارير ADX.",
    workforce_metrics: "مقاييس القوى العاملة",
    workforce_desc: "بيانات الموظفين لسنة التقرير",
    total_employees_label: "إجمالي الموظفين",
    female_pct: "الموظفات (٪)",
    local_pct: "التوطين / القوى العاملة المحلية (٪)",
    training_hours: "ساعات التدريب لكل موظف",
    injury_rate: "معدل إصابات العمل (LTIR)",
    csr_spend: "إنفاق المسؤولية الاجتماعية / الاستثمار المجتمعي",
    supply_chain_practices: "ممارسات سلسلة التوريد",
    wellbeing_programs: "برامج الرفاهية",
    hr_policies: "سياسات الموارد البشرية",
    social_images: "صور القسم الاجتماعي",
    social_images_desc: "ارفع صوراً لأقسام المجتمع في ملف PDF",
    // Governance Step
    gov_hint: "تغطي بيانات الحوكمة مجلس الإدارة والأخلاقيات والامتثال والرقابة على ESG. ضرورية لمتطلبات تقارير ADX.",
    governance_metrics: "مقاييس الحوكمة",
    governance_desc: "الرقابة على مجلس الإدارة والأخلاقيات والامتثال",
    board_size: "حجم مجلس الإدارة",
    board_female: "عضوات مجلس الإدارة (٪)",
    independent_directors: "المديرون المستقلون (٪)",
    anti_corruption: "سياسة مكافحة الفساد",
    whistleblower: "آلية الإبلاغ عن المخالفات",
    data_protection: "سياسة حماية البيانات",
    code_of_conduct: "مدونة قواعد السلوك",
    esg_committee: "لجنة ESG",
    improvement_plan: "خطة التحسين",
    gov_image: "صورة قسم الحوكمة",
    gov_image_desc: "ارفع صورة رئيسية لصفحة فاصل قسم الحوكمة",
    // Generate Step
    scores_summary: "ملخص درجات ESG",
    environmental_label: "البيئة",
    social_label: "الاجتماعي",
    governance_label: "الحوكمة",
    overall_score: "الدرجة الإجمالية لـ ESG",
    ready_generate: "جاهز لإنشاء تقريرك",
    generate_desc: "سيكتب الذكاء الاصطناعي تقرير ESG شاملاً يتجاوز 60 صفحة بناءً على بياناتك، متوافقاً مع معايير GRI العالمية 2021، وتوصيات TCFD، وإرشادات الإفصاح عن ESG الخاصة بـ ADX، ودليل DFM لإعداد تقارير ESG، وأهداف الأمم المتحدة للتنمية المستدامة (مُهيّأ للتوافق المستقبلي مع ISSB و CSRD).",
    generate_button: "إنشاء تقرير ESG",
    generating_text: "جاري الإنشاء...",
    // Report View
    esg_report: "تقرير ESG",
    download_pdf: "تحميل PDF",
    edit_data: "تعديل البيانات",
    regenerate: "إعادة كتابة النص (بنفس البيانات)",
    branding: "العلامة التجارية",
    download_full: "تحميل تقرير PDF الكامل (60+ صفحة)",
    pdf_desc: "ملف PDF احترافي مع صفحة غلاف وجداول بيانات ومؤشر GRI والمزيد",
    // Selects
    yes_formal: "نعم، سياسة رسمية معتمدة",
    in_development: "قيد التطوير",
    no_option: "لا",
    yes_anonymous: "نعم، قناة إبلاغ مجهولة متاحة",
    yes_compliant: "نعم، متوافق مع PDPL/GDPR",
    select_option: "اختر...",

    // ─── Navigation ───
    nav_home: "الرئيسية",
    nav_why_us: "لماذا نحن",
    nav_features: "المزايا",
    nav_creator: "المؤسِّس",
    nav_founders: "المؤسسون",
    nav_get_started: "ابدأ الآن",
    nav_pricing: "الأسعار",
    hero_price_line_amount: "$499 / سنة",
    hero_price_line_offer: "خصم 50٪ حتى 31 أكتوبر",
    hero_price_line_link: "تفاصيل الأسعار",
    pricing_cta_sample_first: "شاهد نموذجًا أولًا",
    pricing_risk_reversal: "عاين تقريرك الكامل قبل الدفع.",
    nav_compare: "نموذج التقرير",
    nav_sample: "نموذج التقرير",
    nav_sign_in: "تسجيل الدخول",
    nav_sign_up: "تسجيل مجاني",
    nav_back_home: "العودة إلى الرئيسية",
    nav_advisors: "محترفو ESG",
    loading: "جارٍ التحميل",
    cancel: "إلغاء",

    // ─── ESG Professionals ───
    advisors_eyebrow: "شبكة محترفي ESG",
    advisors_title: "محترفو ESG",
    advisors_subtitle: "دليل للمحترفين وشركات الاستشارات المستقلة في مجال الاستدامة. تصفح الملفات، صفِّ حسب الدولة أو المدينة أو التخصص، وتواصل معهم مباشرة.",
    advisors_generate_mine: "أنشئ ملفك الاحترافي",
    advisors_edit_my: "تعديل ملفي",
    advisors_search_placeholder: "ابحث بالاسم أو الشركة أو كلمة مفتاحية…",
    advisors_search_btn: "بحث",
    advisors_clear: "مسح",
    advisors_all_countries: "كل الدول",
    advisors_all_cities: "كل المدن",
    advisors_all_services: "كل الخدمات",
    advisors_empty_title: "لا يوجد محترف يطابق المرشّحات.",
    advisors_empty_hint: "جرّب توسيع البحث، أو كن أول من ينشر ملفًا.",
    advisors_not_found: "لم يتم العثور على المحترف.",
    advisors_back_gallery: "العودة إلى المعرض",
    advisors_pending_banner: "ملفك قيد مراجعة الإدارة. سيظهر في المعرض بعد الموافقة.",
    advisors_rejected_title: "ملف مرفوض",
    advisors_about: "نبذة",
    advisors_services: "الخدمات",
    advisors_contact: "التواصل",
    advisors_create_title: "أنشئ ملف المحترف الخاص بك",
    advisors_edit_title: "تعديل ملف المحترف",
    advisors_form_subtitle: "املأ بياناتك أدناه. الحقول التي عليها * إلزامية. يصبح ملفك مرئيًا بعد مراجعة الإدارة.",
    advisors_f_image: "صورة الملف (شعار أو صورة شخصية)",
    advisors_f_company_name: "اسم الشركة",
    advisors_f_first_name: "الاسم الأول",
    advisors_f_last_name: "اسم العائلة",
    advisors_f_email: "البريد الإلكتروني",
    advisors_f_phone: "الهاتف",
    advisors_f_city: "المدينة",
    advisors_f_country: "الدولة",
    advisors_f_hero_message: "رسالة التعريف",
    advisors_f_bio: "نبذة قصيرة",
    advisors_f_services: "الخدمات",
    advisors_f_website: "الموقع الإلكتروني (اختياري)",
    advisors_f_linkedin: "LinkedIn (اختياري)",
    advisors_hero_hint: "سطر واحد قصير يعكس عرض القيمة لديك. بحد أقصى 160 حرفًا.",
    advisors_bio_placeholder: "عرِّف العملاء المحتملين بشخصيتك وخبرتك ونوع المهام التي تنفذها. الحد الأدنى 20 حرفًا.",
    advisors_services_hint: "اختر ما ينطبق عليك. لا تجد تخصصك؟ أضفه أدناه.",
    advisors_custom_tag_placeholder: "أضف تخصصًا مخصصًا…",
    advisors_add: "إضافة",
    advisors_change_image: "تغيير الصورة",
    advisors_upload_image: "رفع صورة",
    advisors_image_hint: "JPEG أو PNG أو WEBP. بحد أقصى 5 ميجابايت. يتم اقتصاص مربع من الوسط، وتُعرض كدائرة.",
    advisors_image_too_big: "يجب ألا تتجاوز الصورة 5 ميجابايت",
    advisors_missing_field: "حقل إلزامي ناقص",
    advisors_missing_image: "يرجى رفع صورة الملف",
    advisors_pick_tag: "اختر خدمة واحدة على الأقل",
    advisors_bio_short: "يجب أن تكون النبذة 20 حرفًا على الأقل",
    advisors_save: "حفظ التعديلات",
    advisors_create_submit: "إنشاء ملفي",
    advisors_saved_pending: "تم الحفظ! الملف قيد المراجعة.",
    advisors_delete: "حذف الملف",
    advisors_delete_confirm: "حذف ملف المحترف؟ لا يمكن التراجع.",
    advisors_deleted: "تم حذف الملف.",

    // ─── Landing Hero ───
    hero_badge: "تسجيل مجاني · بدون بطاقة ائتمان · بدون التزام",
    hero_title_a: "تقارير ESG احترافية.",
    hero_title_b: "في أقل من ساعة، لا أشهر.",
    hero_desc: "أنشئ تقارير ESG احترافية تتجاوز 60 صفحة، متوافقة مع GRI و TCFD و ADX و DFM وأهداف الأمم المتحدة للتنمية المستدامة و ISSB و CSRD. باللغتين العربية والإنجليزية. مُصمَّمة للمؤسسات الصغيرة والمتوسطة. بتكلفة تُعادل واحداً من مئة من تكلفة أكبر أدوات إعداد تقارير ESG المؤسسية.",
    hero_free_intro: "سجّل مجاناً خلال 10 ثوانٍ واحصل فوراً على:",
    hero_free_1: "وصول مجاني إلى لوحة تحكمك الخاصة",
    hero_free_2: "وصول مجاني إلى أخبار ESG العالمية، تغطية يومية منتقاة من الخليج والعالم",
    hero_free_3: "أنشئ تقرير ESG الأول، وقم بتنزيل نسخة تجريبية من 10 صفحات مجانًا",
    hero_unlock_intro: "عندما تكون جاهزاً، افتحه واحصل على:",
    hero_unlock_1: "تقريرك الأول، جاهز للتنزيل",
    hero_unlock_2: "365 يوماً من إنشاء تقارير جديدة بلا حدود",
    hero_unlock_3: "تعديلات غير محدودة على كل تقرير تملكه",
    hero_price_line: "رسم واحد (عرض مبكر حتى 31 أكتوبر): 499 دولاراً لسنة كاملة. بدون تجديد تلقائي، بدون رسوم إضافية.",
    hero_reassurance: "بدون بطاقة ائتمان عند التسجيل. الدفع فقط عند الفتح.",
    popup_start_free: "ابدأ مجاناً",
    popup_close: "إغلاق",
    hero_cta_start: "ابدأ مجانًا",
    hero_cta_subscribe: "اشترك",
    hero_cta_learn: "اعرف المزيد",
    hero_cta_assumptions: "المتطلبات المطلوبة",
    hero_cta_compare: "نموذج التقرير",
    hero_cta_sample: "نموذج التقرير",
    badge_gri: "GRI",
    badge_tcfd: "TCFD",
    badge_adx: "ADX",
    badge_dfm: "DFM",
    badge_sdg: "UN SDGs",
    badge_issb: "ISSB",
    badge_csrd: "CSRD",
    badge_forward_label: "تهيؤ مستقبلي",

    // ─── Sample Page ───
    sample_eyebrow: "مُخرَجات حقيقية · جودة حقيقية",
    sample_hero_a: "هكذا سيبدو",
    sample_hero_b: "تقريرك.",
    sample_hero_desc: "عشر صفحات فعلية من نموذج تقرير مُولَّد، نفس الجودة الاحترافية التي ستقدّمها للمستثمرين والجهات التنظيمية وأصحاب المصلحة. متوفّر بالعربية والإنجليزية.",
    sample_badge_pages: "أكثر من 60 صفحة",
    sample_badge_bilingual: "ثنائي اللغة EN / AR",
    sample_click_zoom: "اضغط للتكبير",
    sample_cta_start: "ابدأ الآن",
    sample_cta_title: "هل أنت مستعد لإنشاء تقريرك؟",
    sample_cta_desc: "من إدخال البيانات إلى تقرير من 60+ صفحة جاهز للمراجعة في أقل من ساعة. لا قوالب. لا وكالات. فقط أرقامك، مكتوبة باحترافية.",
    sample_cta_button: "ابدأ تقريري",
    // Per-slide captions (Arabic)
    sample_caption_cover:       "غلاف جريء متوافق مع الأطر العالمية. ارفع شعار شركتك وصورة خلفية مخصّصة لهوية بصرية قوية، أو اختر لوناً أحادياً أنيقاً.",
    sample_caption_toc:         "خارطة طريق واضحة عبر 31 قسماً، نظرة عامة، البيئة، الإنسان، الحوكمة، و8 ملاحق متوافقة مع المعايير.",
    sample_caption_materiality: "مصفوفة الأهمية المزدوجة التي تربط موضوعاتك بالأثر التجاري والمجتمعي.",
    sample_caption_sia:         "كل إجراء قمت به مربوط بأهداف الأمم المتحدة للتنمية المستدامة، ومبادئ UNGC، ورموز DFM ESG، تتبّع بمستوى مدققي الحسابات.",
    sample_caption_env:         "فاصل القسم بهوية بصرية مميزة لكل ركيزة، E، S، G. ارفع أي صورة خلفية لإضفاء شخصية على الفاصل وتعزيز قصة علامتك التجارية.",
    sample_caption_energy:      "ملخص الطاقة، رسم بياني دائري لمزيج المصادر، وتفصيل دقيق لكل مدخل وقودي ومتجدد.",
    sample_caption_yoy:         "فروقات سنة على سنة بأسهم اتجاهية، مكاسب سريعة وحقائق صريحة حول التراجعات.",
    sample_caption_social:      "فاصل قسم الأداء الاجتماعي، القوى العاملة، السلامة، التنوع، التدريب، المجتمع، سلسلة التوريد. ارفع أي صورة خلفية لإضفاء شخصية على الفاصل.",
    sample_caption_workforce:   "بيانات الموظفين، التنوع حسب المستوى الإداري، التوزيع العمري، قصة التنوع بالأرقام.",
    sample_caption_gov:         "إطار الحوكمة، الرقابة على مجلس الإدارة، الأخلاقيات، حماية البيانات، دمج ESG. ارفع أي صورة خلفية لإضفاء شخصية على الفاصل.",

    // ─── Register / Sign Up ───
    reg_title: "إنشاء حساب مجاني",
    reg_title_suffix: "(لا حاجة إلى بطاقة)",
    reg_subtitle: "ابدأ في إنشاء تقارير ESG احترافية",
    reg_benefit_headline: "ابدأ بإنشاء أول تقرير ESG احترافي لك، مجانًا.",
    reg_benefit_sub: "بدون بطاقة ائتمان. بدون التزام. فقط ابدأ",
    reg_benefit_1: "تسجيل مجاني، دون الحاجة إلى بطاقة",
    reg_benefit_2: "أنشئ تقرير ESG الأول مجانًا، وقم بتنزيل نسخة تجريبية من 10 صفحات",
    reg_benefit_3: "يبقى تقرير ESG محفوظًا في لوحة التحكم الخاصة بك لمدة 3 أيام",
    reg_benefit_4: "وصول مجاني غير محدود إلى قسم أخبار ESG العالمية",
    reg_benefit_5: "اشترك لفتح تقرير ESG الكامل (أكثر من 60 صفحة) بالنسختين الإنجليزية والعربية، مع عدد لا محدود من التوليدات الجديدة وتعديلات لا محدودة على التقارير الحالية",
    // ─── Tutorial video ───
    tut_eyebrow: "جولة سريعة · دقيقتان",
    tut_card_title: "شاهد كيف يعمل في دقيقتين",
    tut_card_sub: "ابدأ رحلتك في تقارير ESG معنا الآن!",
    tut_pill_label: "شاهد الجولة",
    tut_close: "إغلاق",
    // ─── Subscribe (/subscribe) mode ───
    sub_banner_eyebrow: "رسوم موحدة · عرض مبكر",
    sub_banner_price: "499 دولار / سنة",
    sub_banner_sub: "تقرير ESG كامل (60+ صفحة) بالإنجليزية والعربية، توليدات وتعديلات لا محدودة. بدون تجديد تلقائي.",
    sub_form_title: "أنشئ حسابك للاشتراك",
    sub_form_subtitle: "أدخل بياناتك، ثم أكمل الدفع في الخطوة التالية.",
    sub_submit: "ادفع الآن للاشتراك",
    sub_company: "اسم الشركة",
    sub_company_ph: "اسم شركتك",
    sub_phone: "رقم الهاتف",
    sub_phone_ph: "مثال: 4567 123 50 971+",
    sub_err_company: "يُرجى إدخال اسم الشركة.",
    sub_err_phone: "يُرجى إدخال رقم هاتف صحيح.",
    reg_company: "اسم الشركة",
    reg_company_ph: "اسم شركتك",
    reg_firstname: "الاسم الأول",
    reg_firstname_ph: "الاسم الأول",
    reg_surname: "اسم العائلة",
    reg_surname_ph: "اسم العائلة",
    reg_role: "المنصب / المسمى الوظيفي",
    reg_role_ph: "مثال: مدير تنفيذي، مدير ESG",
    reg_phone: "رقم الهاتف",
    reg_email: "البريد الإلكتروني",
    reg_email_ph: "you@company.com",
    reg_password: "كلمة المرور",
    reg_password_ph: "6 أحرف على الأقل",
    reg_submit: "إنشاء حساب مجاني",
    reg_have_account: "لديك حساب بالفعل؟",
    reg_signin_link: "تسجيل الدخول",
    reg_err_password_len: "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل",
    reg_err_company: "اسم الشركة مطلوب",
    reg_err_firstname: "الاسم الأول مطلوب",
    reg_err_surname: "اسم العائلة مطلوب",
    reg_err_role: "يرجى إدخال المسمى الوظيفي.",
    reg_err_phone: "يرجى إدخال رقم هاتف صحيح.",
    reg_err_generic: "فشل التسجيل",
    login_forgot_password: "هل نسيت كلمة المرور؟",

    // ─── Forgot Password ───
    fp_title: "إعادة تعيين كلمة المرور",
    fp_subtitle: "أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة التعيين.",
    fp_email: "البريد الإلكتروني",
    fp_email_ph: "you@company.com",
    fp_submit: "إرسال رابط إعادة التعيين",
    fp_back_login: "العودة إلى تسجيل الدخول",
    fp_err_generic: "حدث خطأ. الرجاء المحاولة مرة أخرى.",
    fp_sent_title: "تحقق من بريدك الإلكتروني",
    fp_sent_msg_a: "إذا كان هناك حساب لـ ",
    fp_sent_msg_b: " فقد أرسلنا رابط إعادة تعيين كلمة المرور. تحقق من صندوق الوارد ومجلد الرسائل المزعجة.",

    // ─── Reset Password ───
    rp_invalid_title: "رابط إعادة تعيين غير صالح",
    rp_invalid_msg: "رابط إعادة تعيين كلمة المرور غير صالح أو منتهي الصلاحية.",
    rp_invalid_link: "اطلب رابطاً جديداً",
    rp_title: "تعيين كلمة مرور جديدة",
    rp_subtitle: "أدخل كلمة المرور الجديدة أدناه.",
    rp_new: "كلمة المرور الجديدة",
    rp_confirm: "تأكيد كلمة المرور",
    rp_pw_ph: "6 أحرف على الأقل",
    rp_confirm_ph: "كرر كلمة المرور",
    rp_submit: "إعادة تعيين كلمة المرور",
    rp_done_title: "تم إعادة تعيين كلمة المرور!",
    rp_done_msg: "تم تحديث كلمة المرور الخاصة بك. يمكنك الآن تسجيل الدخول.",
    rp_signin: "تسجيل الدخول",
    rp_back_login: "العودة إلى تسجيل الدخول",
    rp_err_pw_len: "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل",
    rp_err_mismatch: "كلمات المرور غير متطابقة",
    rp_err_generic: "فشلت إعادة تعيين كلمة المرور. ربما انتهت صلاحية الرابط.",

    back_to_home: "العودة إلى الرئيسية",

    // ─── Disrupting / Why Us ───
    why_eyebrow: "لماذا ESG Report Builder",
    why_title_a: "نُعيد رسم",
    why_title_b: "سوق تقارير ESG",
    why_p1_strong: "إعداد تقارير ESG",
    why_p1_rest: " ظلّ حكراً على الاستشاريين مرتفعي التكلفة الذين يتقاضون من 50,000 دولار وحتى 150,000 دولار أو أكثر للتقرير الواحد لدى الشركات الكبرى، مما جعله بعيد المنال عن ملايين المؤسسات الصغيرة والمتوسطة التي تُشكّل عصب اقتصاد دول الخليج.",
    why_p2_strong: "نحن نُغيّر هذا الواقع.",
    why_p2_rest: " تُقدّم منصة ESG Report Builder تقارير ESG احترافية تتجاوز 60 صفحة، متوافقة بالكامل مع معايير GRI العالمية 2021، وتوصيات TCFD، وإرشادات الإفصاح عن ESG لسوق أبوظبي (ADX)، ودليل DFM لإعداد تقارير ESG، وأهداف الأمم المتحدة للتنمية المستدامة (مُهيَّأة للتوافق المستقبلي مع ISSB و CSRD)، بتكلفة ",
    why_p2_highlight: "تُعادل تقريباً واحداً من مئة",
    why_p2_tail: " من تكلفة أكبر أدوات إعداد تقارير ESG المؤسسية.",
    why_p3_strong: "محرّكنا ثنائي اللغة",
    why_p3_rest: " يُنتج تقارير بالعربية والإنجليزية بنقرة واحدة، وهو ما لا تُوفّره أيّ من المنصّات المنافسة عند أيّ مستوى سعري. كلّ قسم قابل للتخصيص الكامل، ومُثرى بصور شركتك، وحاملاً لهويّتك البصرية بشعارك وألوانك.",
    why_p4_pre: "رؤيتنا واضحة: ",
    why_p4_strong: "دَمَقرَطة تقارير ESG",
    why_p4_rest: ". كلّ شركة، حتى أصغرها، تستحقّ البدء في رحلة الاستدامة، وامتلاك وثيقة احترافية تدعم نموّها، وتصنيفها الائتماني، ووصولها إلى التمويل الأخضر.",
    why_p5_pre: "تقريرنا ",
    why_p5_strong: "أداة ممتازة للمؤسسات الصغيرة والمتوسطة",
    why_p5_mid: " الراغبة في إدارة تقارير ESG داخلياً، وهو في الوقت نفسه ",
    why_p5_strong2: "مسوَّدة تقرير ESG موثوقة للغاية للشركات الكبرى واستشاريي ESG",
    why_p5_rest: "، إذ يُوفّر أساساً متيناً لتجميع البيانات ذات الصلة دون إنفاق أشهر، قبل إعداد تقرير ESG مؤسسي أكثر تخصيصاً.",
    stat1_value: "90٪",
    stat1_title: "توفير في التكلفة",
    stat1_desc: "مقارنةً بأكبر أدوات إعداد تقارير ESG المؤسسية",
    stat2_value: "+60",
    stat2_title: "صفحة لكل تقرير",
    stat2_desc: "ملف PDF احترافي قابل للتخصيص يتضمّن صفحة غلاف، ومحتوى، ومُحمِّل صور، وجداول بيانات، ورسوماً بيانية، ومؤشّر GRI، وأدوات لأصحاب المصلحة، ومحتوى يُولِّده الذكاء الاصطناعي وفقاً لنشاط شركتك ومعطياتها",
    stat3_value: "عربي/إنجليزي",
    stat3_title: "تقارير ثنائية اللغة",
    stat3_desc: "أنشئ تقريرك بالإنجليزية وترجمه إلى العربية بنقرة واحدة، أو العكس. سابقةٌ في السوق.",

    // ─── Features ───
    features_eyebrow: "مزايا المنصّة",
    features_title: "كلّ ما تحتاجه",
    features_subtitle: "مُصمَّمة خصّيصاً للمؤسسات الصغيرة والمتوسطة في منطقة الخليج والشرق الأوسط لبدء رحلة إعداد تقارير ESG",
    feat_ai_title: "إنشاء بالذكاء الاصطناعي",
    feat_ai_desc: "يُنتج ذكاء اصطناعي متقدّم محتوى ESG شاملاً متخصّصاً حسب القطاع، ومتوافقاً مع الأُطر العالمية",
    feat_pdf_title: "ملف PDF احترافي من 60+ صفحة",
    feat_pdf_desc: "صفحة غلاف، وملخّص تنفيذي، وجداول بيانات، ومؤشّرات أداء رئيسية، ومؤشّر GRI، وأدوات لأصحاب المصلحة، مولَّدة تلقائياً",
    feat_bilingual_title: "ثنائي اللغة EN/AR",
    feat_bilingual_desc: "ترجمة عربية كاملة بدعم RTL. أنشئ أو ترجم بنقرة واحدة",
    feat_co2_title: "حاسبات انبعاثات الكربون",
    feat_co2_desc: "حاسبات مدمجة لانبعاثات النطاق 1 و 2 و 3 بمعاملات شبكة كهرباء مخصّصة لدول الخليج",
    feat_brand_title: "هويّة بصرية كاملة",
    feat_brand_desc: "ارفع شعارك، واختر ألوان علامتك. أضِف صور شركتك إلى الأقسام الرئيسية",
    feat_standards_title: "GRI · TCFD · ADX · DFM · SDGs",
    feat_standards_desc: "متوافق مع معايير GRI العالمية 2021، وتوصيات TCFD، وإرشادات الإفصاح عن ESG لسوق أبوظبي (ADX)، ودليل DFM لإعداد تقارير ESG، وأهداف الأمم المتحدة للتنمية المستدامة (مُهيَّأ للتوافق المستقبلي مع ISSB و CSRD).",
    feat_bench_title: "مقاييس خليجية مرجعية",
    feat_bench_desc: "قارِن أداء شركتك بالمتوسّطات الإقليمية للقطاع عبر مقاييس مرجعية مدمجة",
    feat_matrix_title: "مصفوفة الأهمية النسبية",
    feat_matrix_desc: "تقييم الأهمية النسبية المزدوجة بشكل تلقائي مع رسم فقّاعي بصري",
    feat_stake_title: "أدوات أصحاب المصلحة",
    feat_stake_desc: "رسائل جاهزة للمستثمرين، ومنشورات LinkedIn، وقوالب للصحافة مُدرجة ضمن كلّ تقرير",

    // ─── Creator ───
    creator_eyebrow: "المؤسِّس",
    creator_title: "تعرَّف إلى العقل وراء المنصّة",
    creator_location: "دبي، الإمارات",
    creator_name: "ديفيد بروفنزاني",
    creator_role: "قيادي تجاري تنفيذي | خبير في منطقة الشرق الأوسط ودول الخليج",
    creator_bio: "بخبرة تزيد عن 25 عاماً في القيادة التنفيذية في قطاعَي الطاقة المتجدّدة والبنية التحتية، أسّس ديفيد منصّة ESG Report Builder انطلاقاً من قناعة بسيطة: كلّ شركة، مهما كان حجمها، تستحقّ الوصول إلى تقارير ESG احترافية دون تحمُّل التكاليف الباهظة للاستشارات التقليدية.",
    creator_credit1_title: "أستاذ فخري",
    creator_credit1_sub: "جامعة أميتي دبي",
    creator_credit2_title: "أكثر من 30 عاماً في قطاع الاستدامة",
    creator_credit2_sub: "الطاقة المتجدّدة، البنية التحتية، والاستشارات في مجال ESG",
    creator_credit3_title: "رائد أعمال ومدير تنفيذي أوّل",
    creator_credit3_sub: "15 عاماً من الخبرة في منطقة الخليج",
    creator_credit4_title: "مؤسِّس برنامج المدارس الشمسية في دبي",
    creator_credit4_sub: "رائد في تعليم الاستدامة في الإمارات",
    creator_credit5_title: "ضمن أفضل 50 شخصية في الذكاء الاصطناعي في منطقة الخليج",
    creator_credit5_sub: "المصدر: Deep Knowledge Analytics",

    // ─── Trust / Data Integrity ───
    trust_eyebrow: "سلامة البيانات بالتصميم",
    trust_title_a: "ست طبقات حماية.",
    trust_title_b: "صفر تناقضات رقمية.",
    trust_desc: "كل مطالبة كمية في تقريرك تخضع للمطابقة عبر منظومة آلية لسلامة البيانات قبل نشره، الانضباط ذاته الذي يطلبه عملاء شركات التدقيق من Sphera و Workiva و Watershed.",
    trust_l1_title: "مصدر بيانات موحَّد",
    trust_l1_desc: "كل مؤشر أداء، من انبعاثات النطاق 1/2/3 إلى معدل LTIR وساعات التدريب ونسب الجنس، يُسجَّل مرة واحدة في سجل واحد بقاعدة البيانات. جميع السرود والأشرطة ومربّعات المؤشرات والملخّصات التنفيذية وفهرس المحتويات والرسوم البيانية في الملف والترجمات العربية تقرأ من القيمة نفسها. لا يوجد مسار في الشيفرة يسمح للذكاء الاصطناعي أو محرّك التخطيط أو المُترجم بإدخال رقم منافس، مما يضمن أن كل صفحة من تقريرك تتّسق مع الرقم الذي أدخلته في النموذج.",
    trust_l2_title: "الإلزام على مستوى التوجيه",
    trust_l2_desc: "يتلقى النموذج اللغوي القيم القانونية داخل هيكل توجيه محكم يضمّ أكثر من 40 قاعدة تحظّر عليه اختلاق مؤشر جديد، أو استبدال الإجمالي بمقدار نطاق، أو إعادة جمع المكوّنات، أو إحاطة رقم بهدف منافس، أو التقريب بشكل مختلف بين النسختين. أي سرد يتناقض مع بياناتك يُعاد إنشاؤه ثلاث مرات ثم يُحجب. يُلغي هذا فئة الهلاوس التي أوقعت شركات مثل Salesforce وJPMorgan في تناقضات ESG عام 2024.",
    trust_l3_title: "تنقية ما بعد التوليد (34 مُصحِّحاً)",
    trust_l3_desc: "ثلاثة وثلاثون مُصحِّحاً قانونياً قائماً على تعابير منتظمة يعيد كتابة تناقضات النطاق 1/2/3، وتناقضات معدل LTIR، وانحرافات المقارنة السنوية للانبعاثات، وأخطاء توزيع الجنس، وتبديل العملات، والادعاءات الخاطئة بشأن إصابات المقاولين، والأرقام المدمجة الخاطئة، وادعاءات التأكيد من طرف ثالث، وانحرافات المعايير الخليجية، وأخطاء عدد أهداف SDG، والتباينات في عدد أصحاب المصلحة، وأخطاء معامل الشبكة القُطرية، والتلوث المتبادل للقيم بين المقاييس، والخلط بين هدف التخفيض والتخفيض الفعلي، وعدد الموضوعات الجوهرية.",
    trust_l4_title: "مراجعة عند الإخراج",
    trust_l4_desc: "قبل تركيب ملف PDF بأجزاء من الثانية، تُنفَّذ جولة تنقية ثانية تعيد فحص كل فقرة مقابل السجل القانوني للمؤشرات، وتلتقط أي انحراف تسبَّب به النموذج أثناء الترجمة أو توسيع الجمل أو إعادة ترتيب الفقرات. إذا وجد الفحص أي تناقض، يُعاد كتابة الكتلة من القيمة القانونية أو تُقتطع بدل شحنها. طبقة أمان مزدوجة رصدت 71 حالة انحراف حقيقية في تقارير الإنتاج منذ يناير 2026.",
    trust_l5_title: "قفل تطابق EN ↔ AR",
    trust_l5_desc: "تُقيَّد الفقرات العربية هيكلياً وفق النص الإنجليزي الأصلي بنسبة توافق أحرف لا تقلّ عن 0.90، بحيث تحمل النسختان أرقاماً متطابقة تماماً وعدداً متطابقاً من النقاط وصفوف الجداول. لا يستطيع خطّ الترجمة أن يوسّع المحتوى أو يقلّصه كما تفعل محرّكات الترجمة الآلية العامّة، ويجري توحيد كل رمز عملة وفاصل عشري وشكل رقم من اليمين إلى اليسار. يقرأ مستثمرك العربي الأرقام نفسها التي يقرأها مجلس إدارتك بالإنجليزية.",
    trust_l6_title: "اختبارات انحدار مثبَّتة",
    trust_l6_desc: "ستة اختبارات لسلامة البيانات، تشمل قفل SHA-256 للتقرير، واختبار الأرقام القانونية في PDF الإنجليزي، واختبار تكافؤ عدد صفحات EN/AR، واختبار انحراف موضوعات الجوهرية، واختبار معامل الشبكة للنطاق 2، واختبار الترجيع لساعات التدريب، مثبَّتة في خط التكامل المستمر. لا يمكن لأي تعديل أو ترقية نموذج أن تُخِلَّ بأي من الضمانات الستة بصمت. كل نشر يُثبت أن الضمانات لا تزال قائمة قبل أن يراها عملاؤك.",
    trust_footer: "المنهجية الكاملة للطبقات الست موثَّقة داخل كل تقرير PDF (بيان سلامة البيانات · GRI 2-4 · GRI 2-5 · ESRS 1 BP-2).",

    // ─── Pricing ───
    pricing_eyebrow: "ابدأ الآن",
    pricing_title_a: "خطّة واحدة.",
    pricing_title_b: "تقارير بلا حدود.",
    pricing_discount_banner: "عرض محدود · خصم 50٪ حتى 31 أكتوبر 2026",
    pricing_price: "499 $",
    pricing_per_year: "/سنوياً",
    pricing_strike: "999 $/سنوياً",
    pricing_discount_note: "، خصم 50٪ حتى 31 أكتوبر 2026",
    feature_unlimited: "تقارير ESG غير محدودة",
    feature_pdf: "ملف PDF احترافي من 60+ صفحة",
    feature_bilingual: "ثنائي اللغة EN/AR",
    feature_ai_content: "محتوى مُولَّد بالذكاء الاصطناعي",
    feature_branding: "تخصيص العلامة التجارية",
    feature_standards: "التوافق مع GRI و TCFD و ADX و DFM وأهداف التنمية المستدامة",
    feature_uploads: "رفع الصور لكلّ قسم",
    feature_toolkit: "أدوات أصحاب المصلحة",
    feature_benchmarks: "مقاييس خليجية مرجعية",
    feature_matrix: "مصفوفة الأهمية النسبية",
    // ─── Pricing: Human Assistance hooks ───
    pricing_human_badge: "بدعم بشري",
    pricing_human_title: "أشخاص حقيقيون. مساعدة حقيقية. مضمّنة.",
    pricing_human_1_title: "خط مباشر مع رئيسنا التنفيذي",
    pricing_human_1_desc: "بعد الاشتراك، ستحصل على رقم واتساب الشخصي لرئيسنا التنفيذي. يرحّب بك بنفسه ويرشدك في خطواتك التالية.",
    pricing_human_2_title: "توجيه مباشر أثناء إعداد تقريرك الأول",
    pricing_human_2_desc: "نبقى على تواصل معك أثناء بناء أول تقرير ESG، كل سؤال، كل حقل، كل تصدير. لن تكون وحدك أبدًا.",
    pricing_human_footnote: "هذا ليس دعم روبوت محادثة. بل مساعدة بشرية بمستوى المؤسّس، مضمّنة في اشتراكك.",
    pricing_soon_title: "متاح الآن",
    pricing_soon_desc: "ادفع مرّة واحدة واحصل على سنة كاملة من تقارير ESG غير المحدودة، بالعربية والإنجليزية. ثبّت سعر الإطلاق قبل 31 أكتوبر 2026.",
    interest_placeholder: "بريدك الإلكتروني",
    interest_cta: "احجز مقعدك",
    interest_sending: "جارٍ الإرسال…",
    interest_success_title: "تمّ تسجيلك!",
    interest_success_desc_pre: "سنُعلمك على ",
    interest_success_desc_post: " فور إطلاق المنصّة مع خصم 50٪ مُحرَز.",
    interest_error_generic: "تعذّر الإرسال الآن، حاول مجدّداً أو راسلنا على info@architaly.green.",
    have_account_pre: "لديك حساب بالفعل؟ ",
    have_account_link: "تسجيل الدخول",

    // ─── Footer ───
    footer_copy: "© 2026 ESG Report Builder Corp. جميع الحقوق محفوظة.",
    footer_location: "ديلاوير، الولايات المتحدة",
    footer_terms: "الشروط",
    footer_privacy: "الخصوصية",
    footer_refund: "الاسترداد",

    // ─── Compare page ───
    compare_eyebrow: "المشهد التنافسي  ·  فبراير 2026",
    compare_title_a: "كيف تُقارَن ESG Report Builder",
    compare_title_b: "بكلّ البدائل المنافسة الجادّة.",
    compare_intro: "قمنا بتدقيق كلّ منصّة رئيسية لإعداد تقارير ESG تُخدّم المؤسسات الصغيرة والمتوسطة والكبرى، من عمالقة Fortune 2000 مثل Workiva و Datamaran، إلى أدوات المؤسسات الصغيرة الأوروبية مثل Greenly و Pelt8، إلى اللاعبين الإقليميين في الخليج مثل Olive Gaea. هذا هو المشهد الصادق، وهذا هو موقع ESG Report Builder منه.",
    compare_cta_jump: "انتقل إلى المقارنة المباشرة",
    compare_players: "منصّات",
    compare_ideal_for: "مُناسب لـ",
    compare_output: "المخرجات",
    compare_gap: "الفجوة مقارنةً بنا",
    compare_matrix_eyebrow: "المقارنة المباشرة",
    compare_matrix_title: "أين تقف ESG Report Builder",
    compare_col_dim: "المعيار",
    compare_col_others: "الآخرون",
    compare_yes: "نعم",
    compare_no: "لا",
    compare_partial: "جزئياً",
    compare_cta_title_pre: "إن كنت مؤسسة صغيرة أو متوسطة، ابدأ رحلة ESG الخاصّة بك بتقارير احترافية غير محدودة بسعر ",
    compare_cta_title_price: "499 $/سنوياً",
    compare_cta_desc: "التقرير نفسه من 85 صفحة بمستوى تحريري رفيع، بالعربية والإنجليزية، متوافق مع GRI و TCFD و ADX و DFM وأهداف التنمية المستدامة، بتكلفة تُعادل واحداً من مئة من سعر أكبر أدوات إعداد تقارير ESG المؤسسية.",
    compare_sources: "المصادر: fitgap.com، G2، Capterra، المواقع الرسمية للمنصّات، ESG Today، البيانات الصحفية، تمّ التدقيق في فبراير 2026.",

    // Compare Tier 1
    tier1_label: "المستوى 1، عمالقة المؤسسات",
    tier1_range: "50,000 $ – 500,000 $+ سنوياً",
    tier1_note: "مُصمَّمة لشركات Fortune 2000 والشركات المُدرَجة عالمياً. ليست الخيار المُلائم لك، لكنّها مراجع مفيدة.",
    // Compare Tier 2
    tier2_label: "المستوى 2، المؤسسات الصغيرة والمتوسطة الأوروبية",
    tier2_range: "3,000 $ – 80,000 $+ سنوياً",
    tier2_note: "الفئة السعرية الأقرب، لكنّها تُركّز على أوروبا (CSRD/ESRS). بلا عربية، ولا تركيز خليجي، ولا ملفات PDF بمستوى تحريري.",
    // Compare Tier 3
    tier3_label: "المستوى 3، اللاعبون الإقليميون في الخليج والإمارات",
    tier3_range: "ميداننا الفعلي",
    tier3_note: "المعركة الحقيقية. معظمهم شركات استشارات لا منصّات برمجية. واحد فقط منافس مباشر فعلي.",

    // ─── Report View section titles & dividers ───
    rv_eyebrow: "تقرير ESG",
    badge_adx_aligned: "متوافق مع ADX",
    badge_tcfd_framework: "إطار TCFD",
    badge_gri_standards: "معايير GRI",
    score_environmental: "البيئة",
    score_social: "الاجتماعي",
    score_governance: "الحوكمة",
    score_overall: "الدرجة الإجمالية",
    sec_executive_summary: "الملخّص التنفيذي",
    sec_ceo_letter: "رسالة الرئيس التنفيذي",
    sec_company_overview: "نظرة عامة على الشركة",
    sec_materiality: "تقييم الأهمية النسبية",
    div_environmental: "الأداء البيئي",
    sec_env_strategy: "الاستراتيجية البيئية",
    sec_ghg: "تحليل انبعاثات الغازات الدفيئة",
    sec_energy: "إدارة الطاقة",
    sec_water: "إدارة المياه",
    sec_waste: "إدارة النفايات",
    sec_climate_tcfd: "مخاطر المناخ و TCFD",
    sec_env_targets: "الأهداف البيئية",
    div_social: "الأداء الاجتماعي",
    sec_social_strategy: "الاستراتيجية الاجتماعية",
    sec_workforce: "تنوّع القوى العاملة",
    sec_health: "الصحّة والسلامة",
    sec_training: "التدريب والتطوير",
    sec_community: "الانخراط المجتمعي",
    sec_supply: "سلسلة التوريد",
    div_governance: "الحوكمة",
    sec_gov_framework: "إطار الحوكمة",
    sec_board: "تشكيل مجلس الإدارة",
    sec_ethics: "الأخلاقيات والامتثال",
    sec_privacy: "خصوصية البيانات",
    sec_esg_gov: "حوكمة ESG",
    div_appendices: "الملاحق",
    sec_stakeholder: "التفاعل مع أصحاب المصلحة",
    sec_sdg: "التوافق مع أهداف الأمم المتحدة للتنمية المستدامة",
    sec_methodology: "المنهجية",
    sec_forward: "التصريحات الاستشرافية",
    download_btn_prefix: "تحميل PDF",
    preparing: "جارٍ التحضير...",
    translate_prompt_pre: "تريد التقرير باللغة ",
    translate_prompt_mid: "؟ انقر ",
    translate_prompt_post: " بالأعلى.",
    lang_en_name: "الإنجليزية",
    lang_ar_name: "العربية",
    save_branding_btn: "حفظ الهوية البصرية",
    saving: "جارٍ الحفظ...",
    report_branding: "هوية التقرير البصرية",
    report_branding_desc: "خصّص ملف PDF بشعارك وألوان علامتك",
    company_logo: "شعار الشركة",
    upload_logo: "ارفع الشعار",
    translation_missing_title: "لم تتمّ ترجمة التقرير إلى العربية بعد",
    translation_missing_desc: "أنت تعرض هذا التقرير في الوضع العربي، لكنّ نصّ المحتوى لم يُترجَم بعد. اضغط الزرّ أدناه لإنشاء ترجمة عربية كاملة (3–5 دقائق تقريباً).",
    translation_missing_cta: "ترجِم إلى العربية الآن",
    translation_missing_en_title: "لم تتمّ ترجمة التقرير إلى الإنجليزية بعد",
    translation_missing_en_desc: "أنت تعرض هذا التقرير في الوضع الإنجليزي، لكنّ نصّ المحتوى لم يُترجَم بعد. اضغط الزرّ أدناه لإنشاء ترجمة إنجليزية كاملة (3–5 دقائق تقريباً).",
    translation_missing_en_cta: "ترجِم إلى الإنجليزية الآن",
    translation_in_progress: "جارٍ الترجمة… تستغرق 3–5 دقائق. يمكنك مغادرة الصفحة والعودة لاحقاً.",

    // ─── Uncle Dave (Help widget) ───
    uncledave_open: "تحتاج مساعدة؟",
    uncledave_greeting: "أهلاً، أنا العمّ ديف 👋",
    uncledave_subtitle: "ما الذي يشغلك؟ سأنقل رسالتك لفريقنا وسيتواصلون معك في أقرب وقت.",
    uncledave_email_label: "بريدك الإلكتروني",
    uncledave_email_placeholder: "you@company.com",
    uncledave_msg_label: "سؤالك",
    uncledave_msg_placeholder: "أخبرني بما يجري…",
    uncledave_send: "إرسال للفريق",
    uncledave_sending: "جارٍ الإرسال…",
    uncledave_success_title: "تمّ الاستلام!",
    uncledave_success_body: "نقلتُ رسالتك إلى فريق خدمة العملاء، سيتواصلون معك في أقرب وقت على البريد الذي أرفقته.",
    uncledave_close: "إغلاق",
    uncledave_error: "تعذّر إرسال الرسالة. يُرجى المحاولة مجدّداً أو مراسلتنا مباشرة على info@architaly.green.",
    // Report Builder (navigation + progress)
    step_company: "الشركة",
    step_environment: "البيئة",
    step_social: "الاجتماعي",
    step_governance: "الحوكمة",
    step_generate: "الإنشاء",
    progress_step: "الخطوة",
    progress_of: "من",
    report_richness: "ثراء التقرير",
    richness_tooltip: "ثراء التقرير مباشرةً. يتم تقييم كل ما تكتبه فوراً. استهدف 70٪ أو أكثر لكل ركيزة للحصول على تقرير كامل.",
    pillars_below_40_one: "ركيزة تحت 40٪",
    pillars_below_40_many: "ركائز تحت 40٪",
    add_more_data: "، أضِف بيانات أكثر لتحصل على سرد أغنى.",
    // Preflight / low-coverage modals
    heads_up_single: "تنبيه، تم اكتشاف مشكلة واحدة في البيانات",
    heads_up_many: "تنبيه، تم اكتشاف {n} مشكلات في البيانات",
    preflight_body: "لاحظنا ما يلي قبل إنشاء تقريرك. معالجتها الآن ستُنتج تقريراً أقوى وأكثر قابلية للدفاع عنه. يمكنك المتابعة والذكاء الاصطناعي سيُشير إلى الفجوات بأمانة في الإفصاحات.",
    let_me_fix: "دعني أعالجها",
    continue_anyway: "متابعة على أي حال",
    lowcov_body: "يتوقّع تقرير ESG الشامل بيانات ذات معنى عبر الركائز الثلاث. الأقسام التالية مُعبّأة بشكل متناثر، لذا سيكون للذكاء الاصطناعي القليل جداً للعمل عليه وستبدو الفصول الناتجة ضعيفة للقارئ.",
    only_x_filled: "مُعبّأ بنسبة {n}٪ فقط",
    fix_now: "عالِج الآن ←",
    let_me_fill_more: "دعني أُكمل البيانات",
    generate_anyway: "إنشاء على أي حال",
    nudge_title: "خطوات سريعة لرفع ثراء تقريرك",
    nudge_fill_these: "املأ هذه الحقول لتعزيز",
  }
};

export default translations;
